"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PromotionsNotification;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _api = require("@whitbread-eos/api");
var _utils = require("@whitbread-eos/utils");
var _react2 = require("react");
var _icons = require("../../assets/icons");
var _Icon = _interopRequireDefault(require("../Icon"));
var _Notification = _interopRequireDefault(require("../Notification"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function PromotionsNotification(_ref) {
  var {
    promotionBannerData,
    viewType = '',
    page = ''
  } = _ref;
  var {
    showPromo: enabled,
    promoExpiredMessage: expired,
    promoInvalidMessage: invalid,
    promoBannerColour: backgroundColor,
    promoBannerIcon: icon,
    promoBannerTitle: title,
    promoBannerSubtitle: description,
    isWithinPromoWindow: withinWindow
  } = promotionBannerData || {};
  var [hasCellCodes, setHasCellCode] = (0, _react2.useState)(true);
  var [searchParameters, setSearchParameters] = (0, _react2.useState)(null);
  (0, _react2.useEffect)(() => {
    if (typeof window !== 'undefined') {
      var params = new URLSearchParams(window.location.search);
      setSearchParameters(params);
      setHasCellCode(params.has('CELLCODES') || params.has('CORPID'));
    }
  }, []);
  var isBannerEnabled = !invalid && !expired && (viewType === 'banner' || viewType === 'any') && withinWindow && (searchParameters === null || searchParameters === void 0 ? void 0 : searchParameters.has('PROMOID'));
  var isWarningEnabled = (searchParameters === null || searchParameters === void 0 ? void 0 : searchParameters.has('PROMOID')) && (viewType === 'warning' || viewType === 'any') && (invalid || expired);
  var shouldPromoInfoDisplay = !hasCellCodes && enabled && (isBannerEnabled || isWarningEnabled);
  var restrictedPages = [_api.PageName.HDP];
  if (shouldPromoInfoDisplay) {
    return (0, _jsxRuntime.jsxs)(_react.Box, _objectSpread(_objectSpread({
      "data-testid": "PromoContainer"
    }, containerStyles()), {}, {
      children: [isBannerEnabled && (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, getBannerContainerStyles(backgroundColor, viewType)), {}, {
        children: (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({}, bannerTitleStyles(viewType)), {}, {
          children: [(0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({}, bannerIconTitleWrapperStyles), {}, {
            children: [(0, _jsxRuntime.jsx)(_Icon.default, _objectSpread({
              src: (0, _utils.formatAssetsUrl)(icon)
            }, bannerIconStyles)), (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, bannerTitleTextStyles), {}, {
              children: (0, _utils.renderSanitizedHtml)(title)
            }))]
          })), !restrictedPages.includes(page) && description && (0, _jsxRuntime.jsx)(_react.Flex, _objectSpread(_objectSpread({}, bannerDescriptionWrapperStyles), {}, {
            children: (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, bannerDescriptionTextStyles), {}, {
              children: (0, _utils.renderSanitizedHtml)(description)
            }))
          }))]
        }))
      })), isWarningEnabled ? (0, _jsxRuntime.jsx)(_Notification.default, {
        variant: "alert",
        status: "warning",
        description: invalid || expired,
        svg: (0, _jsxRuntime.jsx)(_icons.Alert, {}),
        isInnerHTML: true,
        wrapperStyles: notificationWrapperStyles,
        style: notificationTextStyles,
        prefixDataTestId: "promoBannerWarning"
      }) : null]
    }));
  }
  return null;
}
var notificationWrapperStyles = {
  marginTop: {
    base: 'md',
    md: 'lg'
  },
  zIndex: '1',
  w: '100vw',
  maxW: '100%',
  position: 'relative',
  left: '50%',
  transform: 'translateX(-50%)'
};
var containerStyles = () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  w: 'full',
  position: 'relative',
  bg: 'white',
  marginTop: {
    base: 'md',
    md: 'lg'
  }
});
var getBannerContainerStyles = (bgColor, viewType) => ({
  backgroundColor: bgColor,
  display: 'grid',
  gridTemplateColumns: {
    base: '1fr'
  },
  p: '0.75rem 1rem',
  w: {
    mobile: 'full',
    md: '45rem',
    lg: '50.5rem',
    xl: viewType === 'any' ? '100%' : '54rem'
  },
  borderRadius: viewType === 'warning' ? 0 : '8px',
  lineHeight: '120%',
  minH: 'full',
  alignItems: 'center'
});
var bannerTitleStyles = viewType => ({
  display: 'flex',
  gap: '2px',
  fontSize: 'lg',
  align: 'center',
  alignItems: {
    base: viewType === 'any' ? 'center' : 'flex-start'
  },
  flexWrap: viewType === 'any' ? 'wrap' : 'nowrap',
  flexDirection: {
    base: viewType === 'any' ? 'row' : 'column'
  },
  lineHeight: '120%',
  minH: {
    base: '2.5625rem'
  },
  justifyContent: {
    base: viewType === 'any' ? 'left' : 'center'
  }
});
var bannerIconTitleWrapperStyles = {
  align: 'center'
};
var bannerIconStyles = {
  display: 'inline',
  width: '1rem',
  height: '1rem',
  marginRight: '0.375rem'
};
var bannerTitleTextStyles = {
  as: 'span',
  fontSize: 'lg',
  fontWeight: 'bold',
  color: 'white'
};
var bannerDescriptionWrapperStyles = {
  alignItems: 'center'
};
var bannerDescriptionTextStyles = {
  as: 'span',
  color: 'white',
  fontSize: 'sm',
  fontWeight: 'normal',
  ml: {
    base: 0,
    md: '6px'
  },
  alignItems: 'center'
};
var notificationTextStyles = {
  fontSize: '1rem',
  lineHeight: '1.5rem',
  fontWeight: 'normal',
  border: 0,
  color: 'darkGrey1'
};